import {Component} from '@angular/core';
import {Http} from "@angular/http";
import {Industry} from "../../../models/industry";
import {StaticDataService} from "../../../services/StaticData.service";

declare var jQuery: any;

@Component({
    selector: 'basic',
    templateUrl: 'basic.template.html'
})
export class basicComponent {

    constructor(private http: Http) {
        this.setIndustryList();
    }

    private setIndustryList() {

        let staticService = StaticDataService.getInstance();

        if( staticService.getData() == null){

            let industry = new Industry(this.http);

            industry.getList()
                .map(r => r.json())
                .subscribe(
                    (res) => {
                        staticService.setData(res.data);
                    },
                    (error) => {
                        let errorData = JSON.parse(error._body);
                        console.log(errorData.message);
                    });
        }

    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/layouts/basic.component.ts